import React, { useState } from 'react';
import DesktopLayout from '../layouts/DesktopLayout';
import SecurePropertiesManagement from '../components/SecurePropertiesManagement';

const PropertiesPage = ({ mode = 'list' }) => {
  // Navigation state
  const [activeNavItem, setActiveNavItem] = useState('properties');

  return (
    <DesktopLayout 
      activeNavItem={activeNavItem}
      setActiveNavItem={setActiveNavItem}
      headerTitle="إدارة العقارات"
    >
      <SecurePropertiesManagement mode={mode} />
    </DesktopLayout>
  );
};

export default PropertiesPage;